import React from 'react';

const Footer = () => (
  <footer className="footer">Copyright © 2021 funfunvietnam.com All Rights Reserved.</footer>
)

export default Footer